// The capability endpoint validates current master status and active brand
// access. Beta grants play no part in Concept Boards authorization.
export function canShowTemplateStudioTypes(
  isMaster: boolean | undefined,
  capability: { enabled?: boolean } | undefined,
): boolean {
  return isMaster === true && capability?.enabled === true;
}

// Match only this brand's three existing destinations, never another studio.
export function isConceptBoardsDestination(location: string, boardsUrl: string): boolean {
  const base = boardsUrl.replace(/\/boards$/, "");
  const path = location.split(/[?#]/, 1)[0].replace(/\/$/, "");
  return ["boards", "types", "library"].some((view) => path === `${base}/${view}`);
}

// Retired pins remain harmless in saved preferences; do not write or migrate
// unrelated preferences just because the sidebar mounted.
export function withoutRetiredConceptBoardPins<T extends string>(keys: readonly T[]): T[] {
  return keys.filter((key) => key !== "concept-board-types" && key !== "concept-board-references");
}